

import React, { useState, useEffect } from "react";
import axios from "axios";
import ShimmerLoader from "../../Components/UI-Controls/Loader/ShimmerLoader";
import DataTable from "react-data-table-component";
import Pagination from "../../Components/UI-Controls/Pagination/PaginationRashid";
import CummulativeBox from "./cummulationBox";
import productImg from "../../Assets/Images/product.png"
import avaiProduct from "../../Assets/Images/total-product-1.png"
import inactProduct from "../../Assets/Images/product-inactive-1.png"
import locProduct from "../../Assets/Images/product-loc-1.png"
import { formatCurrencyValue } from "../../Services/Api";
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from "react-accessible-accordion";
import CustomBtn from "../../Components/UI-Controls/Buttons/Btn";
import InputField from "../../Components/UI-Controls/InputField/InputField";
import { FaHandHoldingUsd, FaTimesCircle, FaClipboardList, FaShippingFast, FaUserPlus, FaShoppingCart } from "react-icons/fa";
import CustomDropdown from "../../Components/UI-Controls/Dropdown/dropdown";

import "./style.css";

export default function OfflineInv() {
  const [inventory, setInventory] = useState([]);
  const [filteredInventory, setFilteredInventory] = useState([]);

  const [loading, setLoading] = useState(true);
  const [openDropdownId, setOpenDropdownId] = useState(null);
  const [cummulations, setCummulations] = useState(
    {
      totalProducts: 0,
      availableProducts: 0,
      reservedProducts: 0,
      totalSelling: 0,
      activeProductsCount:0,
      inactiveProductsCount:0
    }
  )

  const customStyles = {
    headCells: {
      style: {
        height: "clamp(50px, 5vw, 56px)",
        background: "transparent",
        textAlign: "center",
        justifyContent: "center",
        border: "none",
        color: "var(--text-color-1)",
        fontFamily: "var(--font-family)",
        fontWeight: "var(--font-weight-medium)",
        fontSize: "clamp(var(--font-size-medium), 0.8vw, calc(var(--font-size-medium) + 2px))",
      },
    },
    cells: {
      style: {
        height: "clamp(50px, 6vw, 66px)",
        justifyContent: "center",
        textAlign: "center",
        background: "transparent",
        borderTop: "var(--standered-border)",
        borderRight: "none",
        color: "var(--text-color-1)",
        fontFamily: "var(--font-family)",
        fontWeight: "var(--font-weight-regular)",
        fontSize: "clamp(var(--font-size-small), 0.8vw, calc(var(--font-size-small) + 2px))",
      },
    },
  };

  const toggleDropdown = (id) => {
    setOpenDropdownId((prevId) => (prevId === id ? null : id));
  };

  const handleAction = (action, row) => {
    console.log(`Action: ${action} triggered for row:`, row);
    setOpenDropdownId(null); // Close dropdown on action
    // Add action logic here
  };

  const OrdersColumns = [
    {
      name: (
        <input
          type="checkbox"
          style={{ margin: 0 }}
          onChange={(e) => console.log("All selected:", e.target.checked)}
        />
      ),
      cell: (row) =>
        loading ? (
          <ShimmerLoader width="20px" height="20px" />
        ) : (
          <input
            type="checkbox"
            style={{ margin: 0 }}
            onChange={(e) => console.log("Selected:", row, e.target.checked)}
          />
        ),
      ignoreRowClick: true,
      width: "50px",
    },
    {
      name: "ID",
      selector: (row) =>
        loading ? (
          <ShimmerLoader width="30px" height="22.5px" borderRadius="10px" />
        ) : (
          row.id
        ),
      minWidth: "150px",
      maxWidth: "170px",
    },
    {
      name: "Product Name",
      selector: (row) => row.product_name,
      minWidth: "350px",
      // maxWidth: "500px",
      cell:  (row) => (
        loading ? (
          <ShimmerLoader width="300px" height="22.5px" borderRadius="20px" />
        ) : (
        <div style={{
          whiteSpace: "normal",
          overflow: "hidden",
          textOverflow: "ellipsis",
          display: "-webkit-box",
          WebkitLineClamp: 2,
          WebkitBoxOrient: "vertical",
          WebkitLineClamp: 2,
        }}>
          {row.product_name}
        </div>
      ))
    },
    {
      name: "SKU",
      selector: (row) => row.sku,
      cell: (row) =>
        loading ? (
          <ShimmerLoader width="100px" height="22.5px" borderRadius="20px" />
        ) : (
          <div style={{
            whiteSpace: "normal",
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            WebkitLineClamp: 2,
          }}>
            {row.sku}
          </div>
        ),
      minWidth: "200px",
      maxWidth: "250px",
    },
    {
      name: "Sale Price",
      selector: (row) => row.selling_price,
      cell: (row) =>
        loading ? (
          <ShimmerLoader width="100px" height="22.5px" borderRadius="20px" />
        ) : (
          <div style={{
            whiteSpace: "normal",
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            WebkitLineClamp: 2,
          }}>
            ${formatCurrencyValue(row.selling_price)}
          </div>
        ),
      minWidth: "120px",
      maxWidth: "200px",
    },
   {
  name: "Available",
  selector: (row) => row.available,
  cell: (row) =>
    loading ? (
      <ShimmerLoader width="100px" height="22.5px" borderRadius="20px" />
    ) : (() => {
      let textColor = "#36454F";
      let backgroundColor = "transparent";

      if (row.available <= 0) {
        textColor = "#F08F9F";
        backgroundColor = "#F08F9F10";
      }

      return (
        <div
          style={{
            color: textColor,
            backgroundColor: backgroundColor,
            padding: "5px 10px",
            borderRadius: "5px",
            boxSizing: "border-box",
            display: "inline-block",
            whiteSpace: "normal",
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            WebkitLineClamp: 2,
            textAlign:"center"
          }}
        >
          {row.available}
        </div>
      );
    })(),
  minWidth: "120px",
  maxWidth: "200px",
}

    // {
    //   name: "Status",
    //   selector: (row) => row.status,
    //   cell: (row) =>
    //     loading ? (
    //       <ShimmerLoader width="100px" height="22.5px" borderRadius="20px" />
    //     ) : (
    //       <div style={{
    //         whiteSpace: "normal",
    //         overflow: "hidden",
    //         textOverflow: "ellipsis",
    //         display: "-webkit-box",
    //         WebkitLineClamp: 2,
    //         WebkitBoxOrient: "vertical",
    //         WebkitLineClamp: 2,
    //       }}>
    //         {row.status==="active"? "Active" :row.status==="notactive"?"Inactive":row.status}
    //       </div>
    //     ),
    //   minWidth: "120px",
    //   maxWidth: "200px",
    // },
    // {
    //   name: "Action",
    //   cell: (row) =>
    //     loading ? (
    //       <ShimmerLoader width="60px" height="22.5px" />
    //     ) : (
    //       <div key={row._id} style={{ position: "relative" }}>
    //         <img
    //           src={actionIcon}
    //           alt="Action Icon"
    //           width="40"
    //           height="40"
    //           style={{ cursor: "pointer", margin: 0, padding: 0 }}
    //           className={`bar-icon ${openDropdownId === row._id ? "rotated" : ""}`}
    //           onClick={() => toggleDropdown(row._id)}
    //         />
    //         {openDropdownId === row._id && (
    //           <div className="dropdown-menu show animate-dropdown-left">
    //             <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
    //               <li onClick={() => handleAction("view", row)}>
    //                 <IoEyeOutline className="icon-img-updated" style={{ marginRight: "12px" }} />
    //                 View
    //               </li>
    //               <li onClick={() => handleAction("edit", row)}>
    //                 <FiEdit className="icon-img-updated" style={{ marginRight: "12px" }} />
    //                 Edit
    //               </li>
    //               <li onClick={() => handleAction("cancel", row)}>
    //                 <RiDeleteBin6Line className="icon-img-updated" style={{ marginRight: "12px" }} />
    //                 Cancel
    //               </li>
    //               <li onClick={() => handleAction("delete", row)}>
    //                 <RiDeleteBin6Line className="icon-img-updated" style={{ marginRight: "12px" }} />
    //                 Delete
    //               </li>
    //             </ul>
    //           </div>
    //         )}
    //       </div>
    //     ),
    //   width: "105px",
    // },
  ];

  useEffect(() => {
    async function fetchData() {
      try {
        const response = await axios.get(
          "https://syncinventory.myfurnituremecca.com/api/v1/product-inventory/get-offline-inventory"
        );

        const data = response?.data || [];

        setInventory(data);
        setFilteredInventory(data);

        const cummulations = data.reduce(
          (acc, item) => {
            acc.totalProducts += 1;
            acc.availableProducts += Number(item.available) || 0;
            acc.reservedProducts += Number(item.reserved) || 0;
            acc.totalSelling += Number(item.selling_price) || 0;

            if (Number(item.available) > 0) {
              acc.activeProductsCount += 1;
            } else {
              acc.inactiveProductsCount += 1;
            }

            return acc;
          },
          {
            totalProducts: 0,
            availableProducts: 0,
            reservedProducts: 0,
            totalSelling: 0,
            activeProductsCount: 0,
            inactiveProductsCount: 0,
          }
        );

        setCummulations(cummulations);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    }

    fetchData();
  }, []);


  const rowsPerPage = 100;
  const [currentPage, setCurrentPage] = useState(1);
  const totalPages = Math.ceil(inventory.length / rowsPerPage);
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handlePrevPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  const paginatedData = filteredInventory.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );



  const placeholderRows = Array(7)
    .fill({ uid: "", name: "", image: "" })
    .map((row, index) => ({ ...row, uid: `placeholder-${index}` }));
  const displayedData = loading ? placeholderRows : paginatedData;

  const [filtersApplied, setFiltersApplied] = useState(false);
  const [filtersModified, setFiltersModified] = useState(false);
  const [productName, setProductName] = useState("");
  const [productSku, setProductSku] = useState("");
  const [productId, setProductId] = useState("");
  const [categoryId, setCategoryId] = useState("");

  const handleFilterChange = (value, fieldName) => {
    if (fieldName === "productName") {
      setProductName(value);
      setSearchTerm(value);

    } else if (fieldName === "productSku") {
      setProductSku(value);
      setSearchTerm(value); // this triggers real-time filtering
    } else if (fieldName === "productCategory") {
      setCategoryId(value);
      setSearchTerm(value);
    } else if (fieldName === "productId") {
      setProductId(value);
      setSearchTerm(value); // optional: if you want ID search too
    }
    setFiltersModified(true);
    setFiltersApplied(true);
  };


  const handleSearch = (searchTerm) => {
    const lowerSearch = searchTerm.toLowerCase();

    const filtered = inventory.filter(item =>
      item.product_name?.toLowerCase().includes(lowerSearch) ||
      item.sku?.toLowerCase().includes(lowerSearch) ||
      item.id?.toString().includes(lowerSearch)
    );

    setFilteredInventory(filtered);
    setCurrentPage(1); // Reset to first page after filtering
  };


  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    const filtered = inventory.filter((item) =>
      item.product_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.sku?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.id?.toString().includes(searchTerm.toLowerCase())
    );
    setFilteredInventory(filtered);
    setCurrentPage(1);
    console.log(filtered)
  }, [searchTerm, inventory]);


  const handleResetFilters = () => {
    setProductName("");
    setProductId("");
    setProductSku("");
    setCategoryId("");
    setSearchTerm("");
    setFiltersApplied(false);
  };


  return (
    <div className="inventory_tab">
      <div className="inventory_tab_cummulations">
        <CummulativeBox name={"Total"} name2={"Products"} value={formatCurrencyValue(cummulations.totalProducts)} unit={"Products"} img={productImg} />
        <CummulativeBox name={"In Stock"} name2={"Products"} value={formatCurrencyValue(cummulations.activeProductsCount)} unit={"Products"} img={avaiProduct} />
        <CummulativeBox name={"Out of Stock"} name2={"Products"} value={formatCurrencyValue(cummulations.inactiveProductsCount)} unit={"Products"} img={inactProduct} />
        <CummulativeBox name={"Active"} name2={"Locations"} value={"9"} unit={"Locations"} img={locProduct} />
      </div>


      <div className="Filters-Section" style={{width:"100%",marginLeft:0,marginTop:"10px"}}>
        <Accordion allowZeroExpanded className="accordion" >
          <AccordionItem>
            <AccordionItemHeading>
              <AccordionItemButton>Filters</AccordionItemButton>
            </AccordionItemHeading>
            <AccordionItemPanel>
              {/* First Row: Labels */}
              <div className="filter-row-01">
                <div className="filter-label">Product Name</div>
                <div className="filter-label">Product SKU</div>
                {/* <div className="filter-label">Product Category</div> */}
                <div className="filter-label">Product ID</div>
              </div>

              {/* Second Row: React Select Fields */}
              <div className="filter-row-02">
                <InputField
                  value={productName}
                  name="productName"
                  onChange={(e) =>
                    handleFilterChange(e.target.value, "productName")
                  }
                  placeholder="Product Name"
                />
                <InputField
                  value={productSku}
                  name="productSKU"
                  onChange={(e) =>
                    handleFilterChange(e.target.value, "productSku")
                  }
                  placeholder="Product SKU"
                />
                <InputField
                  value={productId}
                  name="productId"
                  onChange={(e) =>
                    handleFilterChange(e.target.value, "productId")
                  }
                  placeholder="Product ID"
                />
              </div>


              {/* Fifth Row: Apply Filters Button */}
              <div className="filter-row-04">
                {filtersApplied && (
                  <CustomBtn
                    label="Reset"
                    withIcon={true}
                    iconType="reset"
                    className="ResetBtn-OrderPage"
                    onClick={handleResetFilters}
                    type="button"
                  />
                )}
              </div>
            </AccordionItemPanel>
          </AccordionItem>
        </Accordion>
      </div>

      <div className="Orders-Table-Data" style={{width:"100%",marginLeft:"0"}}>
        <div>
          <DataTable
            columns={OrdersColumns}
            data={displayedData}
            customStyles={customStyles}
            // progressPending={loading}
            persistTableHead
            highlightOnHover
            striped
          />
          <Pagination
            activePageIndex={currentPage}
            totalPages={totalPages}
            onPrevPage={handlePrevPage}
            onNextPage={handleNextPage}
            onPageChange={handlePageChange}
          />
        </div>
      </div>
    </div>
  );
}
